import BannerSectionProducts from './BannerSectionProducts';

export default BannerSectionProducts;